import {map} from 'rxjs/operators';
import { Component, ElementRef, Renderer2, ViewChild} from '@angular/core'
import { OnInit } from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {KeyValue} from '../../shared/key-value';

import {AuthorizationService} from '../../shared/authorization.service';

@Component({
  selector: 'app-decisions-set-popup',
  templateUrl: './decisions-set-popup.component.html',
  styleUrls: ['./decisions-set-popup.component.css']
})
export class DecisionsSetPopupComponent implements OnInit {

  decision_sets:any=[];
  decision_set_name:string="";
  dup_decision_set_name: '';
  current_decision_set:any={};
  role:string="";
  all_teams:any=[];
  current_team:any={}
  disable_button: boolean = false;
  error_message: any;
  duplicate_error_message: any;
  @ViewChild('modalContent', { static: true }) modalContent: ElementRef;
  constructor(
    private router: Router,
    private _tokenService: AngularTokenService,
    public authService: AuthorizationService, 
    private renderer: Renderer2,
    private KeyValueService: KeyValue) 
  {
      this.role = this.authService.getCRole();
  }

  create_decision_set(type) {
    const d_name = type === 'update' ? this.dup_decision_set_name : this.decision_set_name;
    
    //action plan validation
    const alphanumericPattern = /^[a-zA-Z0-9_ ]*$/;
    if (!alphanumericPattern.test(this.decision_set_name)) {
      this.error_message = 'Allow only alphanumeric characters, including underscores and spaces.';
      this.duplicate_error_message = '';
      return; // Stop the function from submitting if validation fails
    }
    if (!alphanumericPattern.test(this.dup_decision_set_name)) {
      this.duplicate_error_message = 'Allow only alphanumeric characters, including underscores and spaces.';
      this.error_message = '';
      return; // Stop the function from submitting if validation fails
    }

    this.set_rate_change(type, this.decision_set_name);
    this.disable_button = true;
    const name = this.current_decision_set.name
    // this.current_decision_set.name = this.decision_set_name
    const d_set = JSON.parse(JSON.stringify(this.current_decision_set)); //this.current_decision_set;
    d_set.name = d_name;
    if (type === 'create') {
      this.current_decision_set.is_submited = false;
    }
    this.authService.post(KeyValue.decisionstatusPath, {decision_set: d_set, type: type}).pipe(
      map(res => res)).subscribe(
      data => {
        if (data.status === 200) {
          document.getElementById('popup_close').click();
          this.duplicate_error_message = '';
          this.error_message = '';
          this.decision_sets = data.decision_sets;
          KeyValue.flash_msg_update({msg: 'Action Plan is created.', type: 'success_messages'});
          this.KeyValueService.decision_sets_update(data);
          const decision_set_obj = this.decision_sets.filter(decision_set => decision_set.name === d_set.name)[0];
          if (decision_set_obj != null || decision_set_obj != undefined){
            console.log('...ind=sidefedf')
            console.log(data)
            this.update_current_decision(data.current_decision_set);
          }
        }else {
          this.current_decision_set.name = name;
          KeyValue.flash_msg_update({msg: 'Action Plan name is already used.', type: 'error_messages'});
        }
        this.enable_button();
      },
      error => {
        console.log('in... signin success' + error)
        KeyValue.flash_msg_update({msg: KeyValue.decision_set_error_while_saving, type: 'error_messages'})
      }
    );
  }

  set_rate_change(type, name) {
    const decision_set_count = this.decision_sets.filter(decision_set => decision_set.name === name).length;
    if (type === 'create' && decision_set_count === 0) {
      this.current_decision_set.treasury_rate_change = null;
      this.current_decision_set.treasury3_rate_change = null;
      this.current_decision_set.treasury120_rate_change = null;
      this.current_decision_set.loan_rate_change = null;
      this.current_decision_set.deposit_rate_change = null;
    }
  }

  enable_button() {
    const ctrl = this;
    setTimeout(function(){
      ctrl.disable_button = false;
    }, 1000);
  }

  check_if_submitted() {
    const decision_set_obj = this.decision_sets.filter(d_set => d_set.is_submited === true);
    if (decision_set_obj.length === 0) {
      return false;
    }else {
      return true;
    }
  }

  check_presence(decision_set_name) {
    if (decision_set_name === undefined || decision_set_name.trim() === '') {
      return true;
    }
  }

  fetch_current_decision(decision_set) {
    this.authService.get(KeyValue.get_decision_set, { params: { dset_id: decision_set.id } }).pipe(
      map(res => res)).subscribe(
      data => {
        console.log(data)
        this.update_current_decision(data)
      },
      error => {
        console.log('erorr...' + error)
      }
    );
  }
  update_current_decision(decision_set) {
    this.DecisionSetHtmlTag(decision_set.name);
    this.current_decision_set = decision_set;
    this.decision_set_name = decision_set.name;
    this.KeyValueService.current_decision_set_update(decision_set);
    this.authService.setCurrentDecisionSet(decision_set);
    // this.KeyValueService.form_load_update('loading_forms');
    this.dup_decision_set_name = '';
    const actionPlanBox = document.getElementById('action-plan-box-1');
    if (actionPlanBox) {
      actionPlanBox.focus();
    }
  }

  DecisionSetHtmlTag(name) {
    if (document.getElementsByClassName('selected-decision-set')[0] === undefined ) {
      const txt_box = document.createElement('input');
      txt_box.type = 'hidden';
      txt_box.className = 'selected-decision-set';
      txt_box.value = name;
      document.getElementsByClassName('student_decision_status_popup')[0].appendChild(txt_box);
    }
  }

  getDecisionStatus(){
    this.authService.get(KeyValue.decisionstatusPath).pipe(
      map(res => res)).subscribe(
      data => {
        console.log(data)
        this.KeyValueService.decision_sets_update(data)
      },
      error => {
        console.log('in... signin success' + error)
      }
    );
  }

  simulationStatusPath(){
    this.router.navigate([this.authService.getChangePath(KeyValue.simulationStatusPath)]);
  }

  setTeam(event){
    this.authService.setTeam({id: event.target.value})
    const ctrl = this;
    setTimeout(function(){
      ctrl.getDecisionStatus()
    }, 1000);
  }
  handleModalKeydown(event: KeyboardEvent): void {
    const focusableElements = this.modalContent.nativeElement.querySelectorAll('a[href], button, textarea, input, select');
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab' && !event.shiftKey) {
      // Tab pressed, move focus to the next element
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    } else if (event.key === 'Tab' && event.shiftKey) {
      // Shift + Tab pressed, move focus to the previous element
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    }
  }

  ngOnInit() {
    this.getDecisionStatus();
    // subscription for decision sets update
    this.KeyValueService.decision_sets$.subscribe(
      data => {
        this.decision_sets = data.decision_sets;
        this.all_teams = data.teams;
        this.current_team = data.current_team === null ? {} : data.current_team;
      });
    this.KeyValueService.current_decision_set$.subscribe(
      data => {
        this.current_decision_set = data;
        if (this.current_decision_set != undefined)
          this.decision_set_name = this.current_decision_set.name
      });

    // Add event listener to trap focus within the modal
    this.renderer.listen(this.modalContent.nativeElement, 'keydown', (event) => {
      this.handleModalKeydown(event);
    });
  }
}